// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__TTnQI","unreadBadge":"styles_unreadBadge__3Q66V","modalContent":"styles_modalContent__39s5I","modal":"styles_modal__1fJf0"};